import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthQuery } from '../state/auth.query';

@Injectable({
  providedIn: 'root',
})
export class AnonymousGuard {
  private authQuery = inject(AuthQuery);
  private router = inject(Router);

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authQuery.isLoggedIn$.pipe(
      map((isLoggedIn) => {
        if (!isLoggedIn) {
          return true; // ✅ User is NOT logged in → allow access
        }

        console.log('AnonymousGuard: User is logged in, redirecting to app');
        return this.router.createUrlTree(['app']); // ❌ User is logged in → Redirect to 'app'
      })
    );
  }
}
